// INIT
document.addEventListener("DOMContentLoaded", function () {

  const script = document.createElement("script")
  script.src = "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
  script.type = "text/javascript"
  document.body.appendChild(script)

  if (document.querySelector("#email_signup")) {
    setTimeout(() => {
      // load Klaviyo subscribe script
      try {
        KlaviyoSubscribe.attachToForms("#email_signup", {
          hide_form_on_success: true,
          custom_success_message: true,
          success_message: "Thanks for subscribe!!",
          extra_properties: {
            $source: "webfooter",
          },
        })
      } catch (e) {
        console.error(e)
      }
    }, 1000)
  }
})

window.addEventListener("load", () => {
    //accessibility widget
  ;(function () {
    var s = document.createElement("script")
    var h = document.querySelector("head") || document.body
    s.src = "https://acsbapp.com/apps/app/dist/js/app.js"
    s.async = true
    s.onload = function () {
      acsbJS.init({
        statementLink: "",
        footerHtml: "",
        hideMobile: false,
        hideTrigger: true,
        disableBgProcess: false,
        language: "en",
        position: "left",
        leadColor: "#146ff8",
        triggerColor: "#146ff8",
        triggerRadius: "50%",
        triggerPositionX: "right",
        triggerPositionY: "bottom",
        triggerIcon: "people",
        triggerSize: "medium",
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: "small",
          triggerPositionX: "right",
          triggerPositionY: "bottom",
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: "50%",
        },
      })
    }
    h.appendChild(s)
  })()
})

document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations, obs) => {
    const btnCookies = document.querySelector("a[aria-label='allow cookies']")
    if (btnCookies) {
      btnCookies.addEventListener("click", () => {
        window.clarity("consent")
      })
      obs.disconnect() // Detenemos la observación una vez encontrado.
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })
})
// INIT

// UTILS
const showMarkets = (event) => {
  const target = event.target
  const container = target.closest(".market-selector")
  // const dropdown = container.querySelector(".market-selector--dropdown")
  container.classList.toggle("is-active")
}
const toggleClassEl = (selector, className) => {
  const el = document.querySelector(selector)
  el.classList.toggle(className)
}
// UTILS

// OKENDO FILTRO POR ESTRELLAS
document.addEventListener("DOMContentLoaded", () => {
  function okeStarsFilters() {
    const okeReviews = document.querySelector(".oke-w-reviews-head")
    const okeRating = document.querySelectorAll(
      ".oke-w-breakdownModule-distribution-label"
    )
    okeRating.forEach((el) => {
      el.addEventListener("click", () => {
        const ratingNumber = el.querySelector(
          ".oke-w-breakdownModule-distribution-label-number"
        ).innerText
        const inputRating = document.querySelector(
          `input[name='Rating ${ratingNumber}'] + label`
        )
        inputRating.click()
        okeReviews.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        })
      })
    })
  }

  const interval = setInterval(() => {
    if (
      document.querySelectorAll(".oke-w-breakdownModule-distribution-label")
        .length > 6
    ) {
      okeStarsFilters()
      clearInterval(interval)
    }
  }, 500)
  if (document.querySelector(".oke-w-reviews-head")) {
    setTimeout(() => {
      clearInterval(interval)
    }, 10000)
  }

})
// OKENDO FILTRO POR ESTRELLAS

//WIZYBOT
const scrollWizyBot = () => {
  const productBtn = document.querySelector(".shop-product__btn")
  if (!productBtn) return
  const isVisible = productBtn.getBoundingClientRect().top >= 0
  const wizybotElement = document.querySelector("div#wizydiv iframe")
  let distanceWizy = "15px"

  if (window.innerWidth <= 1023 && wizybotElement) {
    if (!isVisible) {
      distanceWizy = "90px"
      wizybotElement.style.bottom = distanceWizy
    } else {
      wizybotElement.style.bottom = distanceWizy
    }
  } else if (wizybotElement) {
    wizybotElement.style.bottom = distanceWizy
  }
}
document.addEventListener("DOMContentLoaded", () => {
  scrollWizyBot()
  // window.addEventListener("scroll", () => {
  //   scrollWizyBot()
  // })
})
//WIZYBOT

// KALVIYO TRIGGER POP UP
const href = window.location.href
const kalviyoID = href.split("klaviyo=")[1]; 
if (href.includes("klaviyo=")) {
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', `${kalviyoID}`]);
}
// KALVIYO TRIGGER POP UP

// REBUY FUNCTIONS USED IN SMART CART TEMPLATE
// const changeLinkedProduct = (type, event) => {
//   const container = event.target.closest("[data-key]")

//   let linkedProduct = null
//   container.classList.forEach((className) => {
//     if (className.includes("_linked_product:")) {
//       const [_, value] = className.split(":")
//       linkedProduct = value
//     }
//   })

//   if (linkedProduct) {
//     const linkedProductEl = document.querySelector(
//       `.rebuy-cart__flyout-item[data-id='${linkedProduct}']`
//     )

//     const quantityContainer = linkedProductEl.querySelector(
//       ".rebuy-cart__flyout-item-quantity-widget-label"
//     )
//     const childNodes = quantityContainer.childNodes
//     const textNode = Array.from(childNodes).find((node) => {
//       return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== ""
//     })
//     let quantity = parseInt(textNode ? textNode.nodeValue.trim() : 0)

//     const [decrease, increase] = linkedProductEl.querySelectorAll(
//       ".rebuy-cart__flyout-item-quantity-widget button"
//     )

//     if (type === "-") {
//       quantity--
//       if (quantity === 0) {
//         const dataKey = linkedProductEl.getAttribute("data-key")
//         changeProductQuantity(dataKey, quantity)
//       } else {
//         decrease.click()
//       }
//     } else if (type === "+") {
//       quantity++
//       increase.click()
//     }
//   }
// }
// const changeProductQuantity = async (variantId, quantity) => {
//   try {
//     const response = await fetch("/cart/change.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: quantity,
//       }),
//     })

//     if (!response.ok) {
//       console.error("Hubo un problema al eliminar el producto:", error)
//     }
//   } catch (error) {
//     console.error("Hubo un problema al eliminar el producto:", error)
//   }
// }
// REBUY FUNCTIONS USED IN SMART CART TEMPLATE